import React from "react";
import PropTypes from "prop-types";
import CustomCarousel from "../../components/carousel";
import ErrorMessage from "../buyflow/partials/error";
import LeadButton from "./button";
import LeadInputForm from "./input";
import LeadOtpInput from "./otp";
import NotificationMessage from "../../components/notification";
import InstaPolicyConfirmationAlert from "./alert";
// import PlaceIcon from "@mui/icons-material/Place";
import LocationOnOutlinedIcon from "@mui/icons-material/LocationOnOutlined";

import {
  Alert,
  Box,
  Checkbox,
  FormControlLabel,
  Stack,
  Typography,
} from "@mui/material";
import { exclusiveBanners, options } from "../../defaultValues/lead";
import {
  CHECKBOX_LABEL_DATA_CONSENT,
  DEFAULT_PARTNER_CODE,
  EXCLUSIVE_AVAILABLE_BANNERS_FOR_PARTNER,
  MESSAGE_DATA_CONSENT,
  MESSAGE_SEND_OTP,
  SLUG_LOGIN,
  SLUG_OTP,
} from "../../constants";
import { useStyles } from "./indexStyles";
import { withStyles } from "@mui/styles";
import { rebuildBannersList } from "../../helpers/lead";
import { getStorageItem, redirectWithBlank } from "../../helpers/utils";
import NegativePincodeTable from "./negativePincode";

const LeadForm = ({
  classes: { contentScroller, containerButton, input },
  errorMessage,
  errors,
  form,
  handleChange,
  handleChangeChipSelect,
  handleChangeMobile,
  handleCheckboxChange,
  handleOnClose,
  handleReinitiateJourney,
  isFormSubmitted,
  modal,
  onfocusMobile,
  onSubmit,
  onSubmitGenerateOtp,
  setFormState,
  showOtpInput,
  toggleClass,
  toggleModal,
}) => {
  return (
    <Box>
      <Box
        display={"flex"}
        alignItems={"center"}
        mt={1.5}
        flexDirection={"column"}
      >
        <CustomCarousel
          list={rebuildBannersList(
            options.banners,
            getStorageItem("partnerCode")
          )}
          isPrevNextVisible={false}
          isLabelVisible={false}
        />
        {form.step === SLUG_LOGIN &&
          EXCLUSIVE_AVAILABLE_BANNERS_FOR_PARTNER.indexOf(
            getStorageItem("partnerCode")
          ) > -1 && (
            <Box m={0} textAlign={"center"}>
              <Alert
                variant="filled"
                severity="info"
                icon={false}
                sx={{ padding: 0, backgroundColor: "#035b8a" }}
              >
                <Typography variant="body1">
                  {exclusiveBanners[getStorageItem("partnerCode")].content}
                </Typography>
              </Alert>
            </Box>
          )}
      </Box>

      <Box
        m={1}
        mt={2}
        mb={0}
        sx={{
          color: "secondary.main",
        }}
        // sx={{
        //   backgroundColor: "primary.light",
        //   borderRadius: 2,
        //   boxShadow: 2,
        //   border: "2px solid",
        //   borderColor: "primary.main",
        //   p: 0.5,
        // }}
      >
        <Stack
          justifyContent="flex-start"
          alignItems="center"
          direction="row"
          gap={0.5}
        >
          <LocationOnOutlinedIcon color="white" />
          <Typography
            variant="body1"
            sx={{
              cursor: "pointer",
              textDecoration: "underline",
              textUnderlineOffset: "4px", // Adjust the value as needed
            }}
            onClick={() => toggleModal("pincode", true)}
          >
            Click to check pincode eligibility
          </Typography>
        </Stack>
      </Box>

      <form noValidate autoComplete="off" className={input} onSubmit={onSubmit}>
        <Box className={contentScroller} mt={0}>
          <Box m={1} mt={0} mb={0}>
            <LeadInputForm
              errorMessage={errorMessage}
              form={form}
              handleChange={handleChange}
              handleChangeChipSelect={handleChangeChipSelect}
              onfocusMobile={onfocusMobile}
              toggleClass={toggleClass}
            />
            {form.step === SLUG_OTP && showOtpInput && (
              <LeadOtpInput
                errors={errors}
                errorMessage={errorMessage}
                form={form}
                handleChangeMobile={handleChangeMobile}
                onSubmitGenerateOtp={onSubmitGenerateOtp}
                otp={form.otp}
                setFormState={setFormState}
              />
            )}
          </Box>

          <ErrorMessage errors={errors} />

          {form.step === SLUG_LOGIN && (
            <>
              <Box
                textAlign={"left"}
                mt={0}
                mb={1}
                ml={0.5}
                mr={0.5}
                display={"flex"}
                alignItems="flex-start"
              >
                <Box mt={1}>
                  <FormControlLabel
                    control={
                      <Checkbox
                        checked={form.agree}
                        onChange={handleCheckboxChange}
                        name={"agree"}
                        color="primary"
                      />
                    }
                    label={
                      <Typography variant="caption">
                        <small>{CHECKBOX_LABEL_DATA_CONSENT}</small>
                      </Typography>
                    }
                    sx={{ alignItems: "flex-start" }}
                  />
                </Box>
              </Box>

              {getStorageItem("partnerCode") === DEFAULT_PARTNER_CODE && (
                <Box m={1}>
                  <Typography variant="caption">
                    <small>
                      <b>Caution:</b> Customers to ensure their personal data
                      security and Bank of Maharashtra shall not be liable in
                      case of any data loss.
                    </small>
                  </Typography>
                </Box>
              )}

              <Box m={1}>
                <Typography variant="caption">
                  <small>For ISNP Guidelines,&nbsp;</small>
                </Typography>
                <Typography
                  variant="caption"
                  color="secondary"
                  onClick={() =>
                    redirectWithBlank(
                      "https://www.avivaindia.com/sites/default/files/Turnaround-Times-for-Your-Policy-Servicing-Request.pdf"
                    )
                  }
                >
                  <small>Click Here</small>
                </Typography>
              </Box>
            </>
          )}
        </Box>

        <Box flexDirection="column">
          <Box
            className={containerButton}
            justifyContent="center"
            alignContent="center"
          >
            <LeadButton
              errorMessage={errorMessage}
              form={form}
              isFormSubmitted={isFormSubmitted}
            />
          </Box>
        </Box>
      </form>

      {modal.snackbar && (
        <NotificationMessage
          open={modal.snackbar}
          message={
            form.step === SLUG_OTP ? MESSAGE_SEND_OTP : MESSAGE_DATA_CONSENT
          }
          onClose={() => toggleModal("snakbar", false)}
        />
      )}

      {form.alert && (
        <InstaPolicyConfirmationAlert
          form={form}
          modal={modal}
          onClickHandler={handleReinitiateJourney}
          onClose={handleOnClose}
        />
      )}

      {modal.pincode && (
        <NegativePincodeTable modal={modal} toggleModal={toggleModal} />
      )}
    </Box>
  );
};

LeadForm.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(useStyles, { withTheme: true })(LeadForm);
